import React from 'react';
import _ from 'lodash';
import '../../less/bootstrap.less';

export const invoiceListErrorPage = (invoiceList: any, isTimedOut: boolean) => {
    if (isTimedOut) {
        return (
            <div>
                {invoiceTimeoutPage()}
            </div>
        );
    }

    return (
        <div>
            {_.isEmpty(invoiceList.data) && !invoiceList.invoiceListError && !invoiceList.isExpired && invoiceEmptyErrorPage()}
            {invoiceList && invoiceList.isExpired && invoiceIsExpiredPage()}
            {invoiceList && invoiceList.invoiceListError && invoiceListError()}
        </div>
    );
};

const invoiceEmptyErrorPage = () => {
    const warningMessageHead = 'We couldn\'t find any unpaid invoices';
    const warningMessage = 'Either you\'ve paid all of your invoices (hooray!) or you\'ll need to\n' +
        '                contact your issuing company for more information.';
    return (
        <div className='expired-link-warning'>
            <img src={require('../../assets/img/empty-invoice-list.png')} />
            <h1>{warningMessageHead}</h1>
            <br />
            <p>{warningMessage}</p>
        </div>
    );
};

const invoiceTimeoutPage = () => {
    const warningMessage = 'We thought you weren\'t coming back!';
    return (
        <div className='timeout-warning'>
            <img src={require('../../assets/img/clock_illustration.png')} />
            <h1>Session timeout</h1>
            <br />
            <p>{warningMessage}</p>
            <p>Refresh this page to go back to your invoice list.</p>
        </div>
    );
};

const invoiceIsExpiredPage = () => {
    return (
        <div className='expired-link-warning'>
            <img src={require('../../assets/img/lock_image.png')} />
            <h1>Link expired</h1>
            <br />
            <p>For security reasons this link has expired.</p>
            <br />
            <p>For a new invoice email, contact your issuing company.</p>
        </div>
    );
};

const invoiceListError = () => {
    const warningMessageHead = 'There\'s a lot happening over here...';
    const warningMessage = 'We\'re trying to process your request but we\'re experiencing some\n' +
        '                issues on our end.';
    return (
        <div className='expired-link-warning'>
            <img src={require('../../assets/img/error-construction.png')} />
            <h1>{warningMessageHead}</h1>
            <br />
            <p>{warningMessage}</p>
            <br />
            <p>Please try again in a few minutes.</p>
        </div>
    );
};
